import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HorizontalBarChart from "../../../../components/charts/HorizontalBarChart";
import NoData from "../../../../components/noData/Nodata";
import TileBox from "../../../../components/tile/TileBox";

const SecurityDetails = ({ data }) => {
  const theme = useTheme();
  const { primary, warning, success, error } = theme.palette;
  const isEmpty = Boolean(!Object.keys(data).length);

  const graphData = isEmpty
    ? null
    : [
        { name: "Critical", value: data?.critical || 0, color: error.dark },
        { name: "High", value: data?.high || 0, color: warning.dark },
        { name: "Medium", value: data?.medium || 0, color: warning.light },
        { name: "Low", value: data?.low || 0, color: primary.dark },
        { name: "Passed", value: data?.passed || 0, color: success.dark },
      ];

  return (
    <TileBox title="Security Details">
      <Box width="100%" height="360px">
        {graphData ? (
          <>
            <HorizontalBarChart
              data={graphData}
              margin={{ left: 30, bottom: 20, right: 30 }}
              xLabel="No of issues"
              yLabel="Severity level"
            />
          </>
        ) : (
          <NoData />
        )}
      </Box>
    </TileBox>
  );
};

export default SecurityDetails;
